// @ts-nocheck
import React, { ReactElement, ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { HeaderNavigationContext } from '../../context/HeaderNavigationContext';

export interface NavigationHorizontalProps {
  /** Passed down from the `HeaderNavigation` component */
  className?: string;
  /** Children to display within the `HeaderNavigation` */
  children?: ReactNode;
}

/**
 * Used within the `HeaderNavigation` component when the nav items are displayed in desktop mode.
 * Moves the logic for the active item logic away from the other components.
 * @memberof Internal-Component
 */
export const NavigationHorizontal = ({ className, children }: NavigationHorizontalProps): ReactElement => {
  const { activeMenuID, setActiveMenuID } = useContext(HeaderNavigationContext);
  const [activePosition, setActivePosition] = useState({ left: 0, width: 0 });
  const parentRef = useRef(null);

  useEffect(() => {
    if (activeMenuID === '' || !parentRef) return;
    const activeItem = parentRef.current.querySelector(`#${activeMenuID}`);

    if (activeItem === null) {
      setActiveMenuID('');
      return;
    }
    const { offsetLeft } = activeItem;
    const { width } = activeItem.getBoundingClientRect();
    setActivePosition({ left: offsetLeft - 8, width: width + 16 });
  }, [activeMenuID, parentRef, setActiveMenuID]);

  return (
    <ul ref={parentRef} className={className}>
      {children}
      {activeMenuID !== '' && (
        <span className="lmig-FloatingHeader-nav-menu--highlight" style={{ ...activePosition }} />
      )}
    </ul>
  );
};
